// extracted by mini-css-extract-plugin
export var dividerLine = "_80-3";
export var itemImage = "_80-9";
export var lightDivider = "_80-4";
export var modalContent = "_80-5";
export var modalContentCompact = "_80-6";
export var productCard = "_80-a";
export var productImage = "_80-b";
export var productImageCompact = "_80-7";
export var productImagePlaceholder = "_80-c";
export var productImagePlaceholderCompact = "_80-8";
export var progressBarBackground = "_80-1";
export var progressBarContainer = "_80-0";
export var progressBarFill = "_80-2";